import axios from 'axios';

export default function searchDataRetention(data, config) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };

  const url = config.postDataRetentionSearchUrl;
  return dispatch => dispatch({
    type: 'DATA_RETENTION_FETCH',
    payload: axios({ method: 'post', url, headers, data: { ...data } })
  });
}


// WEBPACK FOOTER //
// ./src/actions/searchDataRetention.js